import type { ReactNode } from "react";

interface EmptyStateProps {
  title: string;
  description?: string;
  /** Aksiyon düğmesi / bağlantı. */
  action?: ReactNode;
  /** "warning": veri yok ama bu beklenmiyor (ör. reçetesiz ürün). */
  tone?: "neutral" | "warning";
}

/**
 * Boş liste durumu.
 * Eski panelde boş liste = bomboş beyaz alan; kullanıcı sorgunun mu çalışmadığını
 * yoksa gerçekten kayıt mı olmadığını anlayamıyordu. Artık açıkça yazıyor.
 */
export function EmptyState({ title, description, action, tone = "neutral" }: EmptyStateProps) {
  const border = tone === "warning" ? "border-amber-300 bg-amber-50/70" : "border-gray-200 bg-white";
  return (
    <div className={`rounded-xl border border-dashed ${border} px-6 py-12 text-center`}>
      <div
        aria-hidden="true"
        className={`mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full ${
          tone === "warning" ? "bg-amber-100 text-amber-700" : "bg-gray-100 text-gray-400"
        }`}
      >
        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" strokeWidth="1.8" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m6 4.125l2.25 2.25m0 0l2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
        </svg>
      </div>
      <p className="text-sm font-semibold text-gray-900">{title}</p>
      {description ? <p className="mt-1 text-sm text-gray-600">{description}</p> : null}
      {action ? <div className="mt-4 flex justify-center">{action}</div> : null}
    </div>
  );
}

export default EmptyState;
